import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const HoursHeader = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: ${toRem(90)};
  grid-auto-rows: ${toRem(44)};
  align-items: center;
  gap: ${toRem(8)};
  padding: 0 ${toRem(16)};
`;

export const Time = styled.div`
  text-align: center;
  font-size: ${toRem(14)};
  font-weight: 400;
  color: ${COLORS.FG.SOFT};
  letter-spacing: 0.02em;
`;

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${toRem(4)};

  background-color: ${COLORS.BG.ELEVATED.XL};
  color: ${COLORS.FG.DEFAULT};

  font-size: ${toRem(14)};
  font-weight: 400;
  line-height: ${toRem(20 / 14)};

  padding: ${toRem(8)} ${toRem(14)};
  border: none;
  border-radius: ${toRem(12)};

  cursor: pointer;
  user-select: none;

  box-shadow: var(--shadow-bottom-xl);

  transition:
    box-shadow 0.2s ease,
    transform 0.15s ease,
    background-color 0.2s ease;

  &:hover {
    box-shadow:
      0 2px 4px rgba(15, 23, 42, 0.06),
      0 6px 16px rgba(15, 23, 42, 0.1);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow:
      0 1px 2px rgba(15, 23, 42, 0.04),
      0 3px 10px rgba(15, 23, 42, 0.08);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
    transform: none;
    box-shadow: none;
  }
`;
